<div class="d-flex align-items-center z-1">
  @if (level === 0 || level === 1) {
    <div class="d-flex flex-row align-items-center text-truncate w-100">
      <div class="fw-bold me-2 text-truncate">
        {{ groupDescriptionId | apmTranslate }}
      </div>
      <span>({{ allChildrenCount }})</span>
    </div>
  }

  @if (level === 2 && rowData) {
    @if (!hideSegmentBorder) {
      <apm-segment-band [segmentIds]="rowData.segmentIds"></apm-segment-band>
    }
    <div class="d-flex flex-column align-items-start justify-content-between w-100">
      <div class="subfamily text-decoration-underline lh-1 pt-3">
        @if (rowData.familySAPCode) {
          <span>[{{ rowData.familySAPCode }}] </span>
          }{{ rowData.subfamilyCode }}
        </div>
        @if (brand) {
          <div class="brand fw-bold lh-1 py-2 mt-3">{{ brand.description }}</div>
        }
      </div>
    }
    @if (showAlerts) {
      <div class="d-flex">
        @if (hasError) {
          <apm-icon
            class="ms-2"
            size="md"
            [matTooltip]="(448641 | apmTranslate) ?? ''"
            icon="i_alert_error"
          ></apm-icon>
        }
        @if (hasConflict) {
          <apm-icon
            class="ms-2"
            size="md"
            [matTooltip]="(448642 | apmTranslate) ?? ''"
            icon="i_alert_rounded"
          ></apm-icon>
        }
      </div>
    }
    @if (!hideActions) {
      <div class="d-flex align-items-center ms-4">
        @if (level !== 2 && actions?.openChangelog) {
          <apm-icon
            size="sm"
            [matTooltip]="(448884 | apmTranslate) ?? ''"
            [isButton]="true"
            [hasHoverIcon]="true"
            (click)="openChangelogDialog()"
            icon="a_activity"
          ></apm-icon>
        }
        @if (canViewDownloadPriceList || canViewMarkup || canManageExtendedWarranties) {
          <apm-icon
            class="ms-2"
            size="sm"
            [matTooltip]="(444976 | apmTranslate) ?? ''"
            [isButton]="true"
            [hasHoverIcon]="true"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            icon="a_menu"
          ></apm-icon>
        }
        <mat-menu #menu="matMenu">
          @if (canViewDownloadPriceList) {
            <div class="px-2">
              <button class="d-flex justify-content-start align-items-center" (click)="exportPriceList()" mat-menu-item>
                <span>{{ 448619 | apmTranslate }}</span>
              </button>
            </div>
          }
          @if (canViewMarkup) {
            <div class="px-2">
              <button class="d-flex justify-content-start align-items-center" (click)="exportMarkup()" mat-menu-item>
                <span>{{ 448620 | apmTranslate }}</span>
              </button>
            </div>
          }
          @if (canManageExtendedWarranties) {
            <div class="px-2">
              <button
                class="d-flex justify-content-start align-items-center"
                (click)="exportExtendedWarranties()"
                mat-menu-item
                >
                <span>{{ 448634 | apmTranslate }}</span>
              </button>
            </div>
          }
          @if (canViewMarkup) {
            <div class="px-2">
              <button
                class="d-flex justify-content-start align-items-center"
                (click)="exportExtendedWarrantiesMarkup()"
                mat-menu-item
                >
                <span>{{ 451622 | apmTranslate }}</span>
              </button>
            </div>
          }
        </mat-menu>
      </div>
    }
  </div>
